var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout md-gutter md-size-100 margin-top-40 md-alignment-center-center justify-content-center"},[_c('md-progress-spinner',{attrs:{"md-diameter":100,"md-stroke":10,"md-mode":"indeterminate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }